import { z } from "zod";
import { ClientAddressType } from "@/lib/api";

/** UFs aceitas pela API (mesma lista de Validators/ClientAddressValidators.cs). */
export const BRAZILIAN_STATES = [
  "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA", "MT", "MS", "MG", "PA",
  "PB", "PR", "PE", "PI", "RJ", "RN", "RS", "RO", "RR", "SC", "SP", "SE", "TO",
] as const;

export const ADDRESS_TYPE_LABELS: Record<ClientAddressType, string> = {
  Billing: "Cobrança",
  Shipping: "Entrega",
};

const requiredText = (message: string, max: number) =>
  z.string().trim().min(1, message).max(max, `Use no máximo ${max} caracteres.`);

/** Formulário de endereço. Só valida o formato do CEP (8 dígitos); correção de CEP está fora do escopo. */
export const addressFormSchema = z.object({
  addressType: z.enum(["Billing", "Shipping"], { required_error: "Selecione a finalidade." }),
  postcode: z
    .string()
    .refine((value) => value.replace(/\D/g, "").length === 8, "Informe um CEP com 8 dígitos."),
  street: requiredText("Informe o logradouro.", 500),
  number: requiredText("Informe o número.", 20),
  district: requiredText("Informe o bairro.", 100),
  complement: z.string().trim().max(100, "Use no máximo 100 caracteres."),
  city: requiredText("Informe a cidade.", 100),
  state: z.string().refine(
    (value) => (BRAZILIAN_STATES as readonly string[]).includes(value.toUpperCase()),
    "Selecione a UF.",
  ),
  label: z.string().trim().max(100, "Use no máximo 100 caracteres."),
  isDefault: z.boolean(),
});

export type AddressFormValues = z.infer<typeof addressFormSchema>;

export const EMPTY_ADDRESS_FORM: AddressFormValues = {
  addressType: "Billing",
  postcode: "",
  street: "",
  number: "",
  district: "",
  complement: "",
  city: "",
  state: "",
  label: "",
  isDefault: false,
};
